export enum ProcessPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    Key = "Key",
    /**
     * 分支条件
     */
    ConditionExpression = 'ConditionExpression',
    /**
     * 流程备注
     */
    wf_TitleExpression = 'wf_TitleExpression',
    /**
     * 默认分支
     */
    Default = 'Default',
    startMode = "startMode",
    wf_ExecuteForms_PC = "wf_ExecuteForms_PC",
    wf_ExecuteForms_Mobile = "wf_ExecuteForms_Mobile",
    wf_Component = "wf_Component",
    processVariables = "processVariables",
    wf_CustomizeAction = "wf_CustomizeAction",
    enablePriority = "enablePriority",
    imageSettings = "imageSettings",
    timeLimitControl = "timeLimitControl",
    messageNotice = "messageNotice",
    allowPreAssign = "allowPreAssign",
    EntryForm = "EntryForm",
    DisplayTerminal = "DisplayTerminal",
    StartCondition = "StartCondition",
    /**
     * 整单撤回审核中单据
     */
    enableWholeOrderRetrieve = 'enableWholeOrderRetrieve',
}